import { render, staticRenderFns } from "./PagesAutoComplete.vue?vue&type=template&id=40a45822&"
import script from "./PagesAutoComplete.vue?vue&type=script&lang=js&"
export * from "./PagesAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports